import { trackEvents } from "./trackEvents";
import { TRACKING_EVENT_NAME } from "./tracking.service";

export function sendPageView(payload: any) {
  trackEvents(TRACKING_EVENT_NAME.PAGE_VIEW, "view", payload);
}
